import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {ApolloClient, InMemoryCache, createHttpLink} from '@apollo/client';
import {createPersistedQueryLink} from '@apollo/link-persisted-queries';
import App from './App';

const cache = new InMemoryCache();
const client = new ApolloClient({
    link: createPersistedQueryLink({useGETForHashedQueries: true}).concat(
        createHttpLink({
            uri: '/ch/graphql',
            headers: {
                'x-csrf-jwt': window.ha.csrfToken,
                'x-homeaway-site': window.analyticsdatalayer.monikerbrand,
            },
        }),
    ),
    // Initialize cache with server side rendered data that was embedded in the page
    cache: cache.restore(window.__APOLLO_STATE__),
});

export const ClientApp: React.FC = () => (
    <BrowserRouter basename={window.__SYSTEM_DATA__.basePath}>
        <App
            client={client}
            homeRoute={window.__HOME_ROUTE__}
            redirects={window.__REDIRECTS__}
            systemData={window.__SYSTEM_DATA__}
            footerData={window.__FOOTER_DATA__}
        />
    </BrowserRouter>
);
